import { connect } from 'react-redux';
import React, { PropTypes } from 'react';
import CaseName from './CaseName';
import { fetchFormIfNeeded } from '../actions/form';
import {
  fetchCustomers,
  selectCustomer,
  createdCustomer,
} from '../actions/customers';
import { getCustomers } from '../reducers/customers';
import { getForm } from '../reducers/form';
import { CustomerSelector } from './CustomerSelector';
import SiteSelector from './SiteSelector';
import ContactSelector from './ContactSelector';
import ExistingCaseState from './ExistingCaseState';
import ExistingCaseType from './ExistingCaseType';
import ExistingCaseYear from './ExistingCaseYear';
import CaseType from './CaseType';
import ExistingCaseConcurrent from './ExistingCaseConcurrent';
import { fetchSites } from '../actions/sites';

const mapStateToProps = (state, ownProps) => ({
  customers: getCustomers(state),
  form: getForm(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchForm: id => dispatch(fetchFormIfNeeded(id)),
  fetchCustomers: () => dispatch(fetchCustomers()),
  fetchSites: customerId => dispatch(fetchSites(customerId)),
  selectCustomer: customerId => dispatch(selectCustomer(customerId)),
  onCustomerCreated: customer => dispatch(createdCustomer(customer)),
});

export class Page extends React.Component {
  componentWillMount() {
    this.props.fetchForm(this.props.id);
    this.props.fetchCustomers();
    if (this.props.customerId > 0) {
      this.props.selectCustomer(this.props.customerId);
      //this.props.fetchSites(this.props.customerId);
    }
  }

  render() {
    const { customers, form, selectCustomer, onCustomerCreated } = this.props;

    return (
      <form className="ui form">
        <ExistingCaseType />
        {form.existingCaseType !== 'NEW' && (
          <div>
            <ExistingCaseState />
            <ExistingCaseYear />
            <CaseType />
          </div>
        )}
        <CaseName />
        <CustomerSelector
          customerId={form.customerId && form.customerId.toString()}
          onChange={selectCustomer}
          customerChoice={customers}
          onCustomerCreated={onCustomerCreated}
          errors={form.errors}
        />
        {form.customerId && <SiteSelector />}
        {form.siteId && <ContactSelector />}
      </form>
    );
  }
}

Page.propTypes = {
  id: PropTypes.number.isRequired,
  customers: PropTypes.array.isRequired,
  form: PropTypes.object.isRequired,
  fetchForm: PropTypes.func.isRequired,
  fetchCustomers: PropTypes.func.isRequired,
  fetchSites: PropTypes.func.isRequired,
  selectCustomer: PropTypes.func.isRequired,
  onCustomerCreated: PropTypes.func.isRequired,
  customerId: PropTypes.number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step1/components/Page.js